import {
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	LAYER_TYPE,
	COMPONENT_DISPLAY_NAME,
} from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/FileUploadField/FileUploadField';
import { defaultProps as fileUploadDefaultProps } from 'client/components/common/BuildingBlocks/Fields/FileUploadField/constants';
import { FieldBBErrorType } from '../constants';
import type { BuildingBlockFactoryProps } from '../../types';

interface Props extends BuildingBlockFactoryProps {}

export const FILE_UPLOAD_FIELD = ({ dictionary }: Props = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.FILE_UPLOAD_FIELD;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
					},

					componentProps: {
						[UNIFORM_PROPS.fieldPlaceholder]: dictionary?.FILE_UPLOAD_FIELD?.placeholder,
						[UNIFORM_PROPS.fileUploadMaxSizeMb]: fileUploadDefaultProps[UNIFORM_PROPS.fileUploadMaxSizeMb],
						[UNIFORM_PROPS.fieldError]: {
							[FieldBBErrorType.required]: dictionary?.FILE_UPLOAD_FIELD.errorRequired,
							[FieldBBErrorType.fileSize]: dictionary?.FILE_UPLOAD_FIELD.errorFileSize,
							[FieldBBErrorType.invalidFileType]: dictionary?.FILE_UPLOAD_FIELD.errorInvalidFileType,
							[FieldBBErrorType.genericError]: dictionary?.FILE_UPLOAD_FIELD.errorGeneric,
						},
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
								},
							},
						},
						other: {},
					},
					nodeProps: {
						id: generateNodeId(_id, type),
					},
				},
				children: [],
			};
		},
	};
};
